export default __webpack_public_path__ + "static/media/sketch-alumni-tn.4f279b26.png";